{
  "REPORT": {
    "HEADER": "Conversations",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "We've not received enough data points to generate report, Please try again later.",
    "DOWNLOAD_AGENT_REPORTS": "Download agent reports",
    "DATA_FETCHING_FAILED": "Failed to fetch data, please try again later.",
    "SUMMARY_FETCHING_FAILED": "Failed to fetch summary, please try again later.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversations",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Messages received",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Messages sent",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "( Total )"
      },
      "REPLY_TIME": {
        "NAME": "Customer waiting time",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Sot",
      "YESTERDAY": "Dje",
      "LAST_7_DAYS": "Last 7 days",
      "LAST_30_DAYS": "Last 30 days",
      "THIS_MONTH": "Këtë muaj",
      "LAST_MONTH": "Muajin e kaluar",
      "LAST_3_MONTHS": "Last 3 months",
      "LAST_6_MONTHS": "Last 6 months",
      "LAST_YEAR": "Last year",
      "CUSTOM_DATE_RANGE": "Custom date range"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Group By",
    "DURATION_FILTER_LABEL": "Duration",
    "GROUPING_OPTIONS": {
      "DAY": "Day",
      "WEEK": "Week",
      "MONTH": "Month",
      "YEAR": "Year"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      },
      {
        "id": 4,
        "groupBy": "Year"
      }
    ],
    "BUSINESS_HOURS": "Business Hours",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "No results found"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Bisedat: {count}",
      "RESULT_COUNT_MESSAGE": "Mesazhet: {count}",
      "EMPTY": "Nuk u gjetën regjistrime për këtë shtyllë.",
      "ERROR": "Regjistrimet nuk u ngarkuan. Provoni përsëri.",
      "LOAD_MORE": "Ngarko më shumë",
      "PREVIOUS_BUCKET": "Shtylla e mëparshme",
      "NEXT_BUCKET": "Shtylla tjetër",
      "UNKNOWN_CONTACT": "Kontakt i panjohur",
      "UNKNOWN_INBOX": "Kuti hyrëse e panjohur",
      "UNASSIGNED_AGENT": "E pacaktuar",
      "NO_MESSAGE_CONTENT": "Mesazh pa përmbajtje",
      "MESSAGE_CREATED_AT": "Mesazhi u krijua më {time}",
      "EVENT_OCCURRED_AT": "Ngjarja ndodhi më {time}",
      "INCOMING_MESSAGE": "Mesazh hyrës",
      "OUTGOING_MESSAGE": "Mesazh dalës",
      "VIEW_ALL": "Shiko te bisedat",
      "VIEW_ALL_LIMIT": "Në listën e bisedave hapen vetëm shtyllat me deri në {limit} biseda.",
      "HIDDEN_COUNT": "Nuk shfaqen sepse nuk jeni anëtar i kutisë së tyre hyrëse: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Agents Overview",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "We've not received enough data points to generate report, Please try again later.",
    "DOWNLOAD_AGENT_REPORTS": "Download agent reports",
    "FILTER_DROPDOWN_LABEL": "Select Agent",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversations",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Incoming Messages",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Outgoing Messages",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Labels Overview",
    "DESCRIPTION": "Ndiqni performancën e etiketave me metrika kryesore, përfshirë bisedat, kohët e përgjigjes, kohët e zgjidhjes dhe rastet e zgjidhura.",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "We've not received enough data points to generate report, Please try again later.",
    "DOWNLOAD_LABEL_REPORTS": "Download label reports",
    "FILTER_DROPDOWN_LABEL": "Select Label",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversations",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Incoming Messages",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Outgoing Messages",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Inbox Overview",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "We've not received enough data points to generate report, Please try again later.",
    "DOWNLOAD_INBOX_REPORTS": "Download inbox reports",
    "FILTER_DROPDOWN_LABEL": "Select Inbox",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversations",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Incoming Messages",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Outgoing Messages",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Team Overview",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Loading chart data...",
    "NO_ENOUGH_DATA": "We've not received enough data points to generate report, Please try again later.",
    "DOWNLOAD_TEAM_REPORTS": "Download team reports",
    "FILTER_DROPDOWN_LABEL": "Select Team",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversations",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Incoming Messages",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Outgoing Messages",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolution Time",
        "DESC": "( Avg )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Resolution Count",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT Reports",
    "NO_RECORDS": "There are no CSAT survey responses available.",
    "DOWNLOAD": "Download CSAT Reports",
    "DOWNLOAD_FAILED": "Failed to download CSAT Reports",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Choose Agents"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Contact",
        "AGENT_NAME": "Assigned agent",
        "RATING": "Rating",
        "FEEDBACK_TEXT": "Feedback comment"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Total responses",
        "TOOLTIP": "Total number of responses collected"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Satisfaction score",
        "TOOLTIP": "Total number of positive responses / Total number of responses * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Response rate",
        "TOOLTIP": "Total number of responses / Total number of CSAT survey messages sent * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Numri i bisedave",
        "TOOLTIP": "Numri total i bisedave me mesazhe nga boti"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Numri i përgjigjeve",
        "TOOLTIP": "Numri total i mesazheve dalëse"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Numri i përgjigjeve nga IA",
        "TOOLTIP": "Numri total i mesazheve me përgjigje të dërguara nga boti"
      },
      "COPILOT_COUNT": {
        "LABEL": "Numri i përgjigjeve të përgatitura",
        "TOOLTIP": "Numri total i sugjerimeve copilot të përgatitura nga boti për agjentët"
      },
      "SUCCESS_RATE": {
        "LABEL": "Zgjidhur nga IA",
        "TOOLTIP": "Përqindja e bisedave të zgjidhura nga IA pa kalim te agjenti"
      },
      "RESOLVE_TIME": {
        "LABEL": "Koha e zgjidhjes",
        "TOOLTIP": "Koha mediane nga mesazhi i parë i klientit deri te mesazhi i fundit i botit/agjentit"
      },
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    },
    "GROUP_BY": {
      "NONE": "Mos grupo",
      "INBOXES": "Kutitë hyrëse",
      "LABELS": "Etiketat"
    },
    "GROUPED": {
      "CHART_TITLE": "Shpërndarja sipas grupit",
      "BACK_TO_ALL": "Shfaq të gjitha",
      "TABLE": {
        "INBOX": "Kutia hyrëse",
        "LABEL": "Etiketa",
        "CONVERSATIONS": "Bisedat",
        "MESSAGES": "Mesazhet",
        "MESSAGES_TOOLTIP": "Numri total i mesazheve dalëse",
        "AI_MESSAGES": "Përgjigje nga IA",
        "AI_MESSAGES_TOOLTIP": "Numri total i përgjigjeve nga IA, i ndjekur nga numri i vlerësimeve pozitive dhe negative të përdoruesve",
        "THUMBS_UP_TOOLTIP": "Numri i përgjigjeve nga IA të vlerësuara pozitivisht (gisht lart) nga përdoruesit",
        "THUMBS_DOWN_TOOLTIP": "Numri i përgjigjeve nga IA të vlerësuara negativisht (gisht poshtë) nga përdoruesit",
        "PREPARED": "Përgjigje të përgatitura",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Përqindja e mesazheve nga të gjitha mesazhet e këtij grupi",
        "BOT_RESPONSES": "% e përgjigjeve nga IA",
        "SUGGESTION_USED": "Përgjigje të përdorura",
        "SUGGESTION_USED_TOOLTIP": "Përqindja e përgjigjeve të përgatitura në këtë grup që u përdorën nga agjentët",
        "SUGGESTION_NOT_USED": "Përgjigje të papërdorura",
        "SUGGESTION_NOT_USED_TOOLTIP": "Përqindja e mesazheve në këtë grup që kishin një përgjigje të përgatitur, por nuk u përdor"
      },
      "NOTES": {
        "TITLE": "Si llogariten metrikat",
        "CONVERSATIONS": "Numri i bisedave që kanë të paktën një mesazh dalës në periudhën e zgjedhur.",
        "MESSAGES": "Numri total i mesazheve dalëse (jo private) të dërguara në periudhën e zgjedhur. Kjo përfshin si mesazhet e krijuara nga IA ashtu edhe ato të shkruara nga njerëzit.",
        "PERCENTAGE": "Pjesa e mesazheve të këtij grupi nga të gjitha mesazhet dalëse në të gjitha grupet.",
        "AI_MESSAGES": "Numri i mesazheve dalëse të dërguara automatikisht nga boti i IA-s (pa përfshirë përgjigjet e përgatitura për agjentët). Numrat në kllapa tregojnë sa nga këto përgjigje u vlerësuan pozitivisht (gisht lart) dhe negativisht (gisht poshtë) nga përdoruesit.",
        "PREPARED": "Numri i sugjerimeve copilot (përgjigje të përgatitura) të krijuara nga boti i IA-s për agjentët në periudhën e zgjedhur. Këto janë mesazhe private, të dukshme vetëm për agjentët, dhe nuk numërohen si mesazhe dalëse, prandaj ky numër mund të mos përputhet me kolonën Mesazhet.",
        "SUGGESTION_USED": "Përqindja e përgjigjeve të përgatitura në këtë grup që u përdorën nga agjentët. Kjo mund të mos përputhet me numrin e Përgjigjeve të Përgatitura sepse mund të përfshijë edhe sugjerime të krijuara në periudha të mëparshme.",
        "SUGGESTION_NOT_USED": "Përqindja e mesazheve dalëse në këtë grup ku ishte i disponueshëm një sugjerim copilot, por agjenti u përgjigj pa e përdorur atë. Numërohet vetëm kur agjenti dërgoi vërtet një përgjigje. Kjo mund të mos përputhet me numrin e Përgjigjeve të Përgatitura sepse mund të përfshijë edhe sugjerime të krijuara në periudha të mëparshme."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Overview",
    "LIVE": "Live",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Open Conversations",
      "LOADING_MESSAGE": "Loading conversation metrics...",
      "OPEN": "Open",
      "UNATTENDED": "Unattended",
      "UNASSIGNED": "Unassigned",
      "PENDING": "Pending"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Conversation Traffic",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Conversations by agents",
      "LOADING_MESSAGE": "Loading agent metrics...",
      "NO_AGENTS": "There are no conversations by agents",
      "TABLE_HEADER": {
        "AGENT": "Agent",
        "OPEN": "Open",
        "UNATTENDED": "Unattended",
        "STATUS": "Status"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Team",
        "OPEN": "Open",
        "UNATTENDED": "Unattended",
        "STATUS": "Status"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Agent status",
      "ONLINE": "Online",
      "BUSY": "Busy",
      "OFFLINE": "Offline"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Add filter",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "No results found",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Agent name",
        "INBOXES": "Inbox name",
        "LABELS": "Label name",
        "TEAMS": "Team name"
      },
      "SLA": "SLA Policy",
      "INBOXES": "Inbox",
      "AGENTS": "Agent",
      "LABELS": "Label",
      "TEAMS": "Team"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "Conversation",
        "AGENT": "Agent"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Nëntotali",
    "NO_TEAM": "Pa ekip",
    "GROUP_BY_TEAMS": "Grupo sipas ekipeve",
    "INBOX": "Inbox",
    "AGENT": "Agent",
    "TEAM": "Team",
    "LABEL": "Etiketë",
    "TOTAL": "Gjithsej",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Resolution Count",
    "CONVERSATIONS": "No. of conversations",
    "OUTGOING_CHATS": "Chat-e dalëse",
    "OUTGOING_EMAILS": "Email-e dalëse",
    "PHONE_CALLS": "Thirrje telefonike",
    "INBOUND_CALLS": "Thirrje hyrëse",
    "OUTBOUND_CALLS": "Thirrje dalëse",
    "TOTAL_ACTIVITIES": "Veprimtaritë gjithsej",
    "ONLINE_TIME": "Koha në linjë",
    "QUEUE_AVAILABLE_TIME": "Koha e disponueshme në radhë",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Numri i mesazheve dalëse të dërguara nga ky agjent",
      "OUTGOING_EMAILS": "Numri i email-eve dalëse të dërguara nga ky agjent",
      "PHONE_CALLS": "Numri total i thirrjeve telefonike të caktuara këtij agjenti (shuma e thirrjeve hyrëse dhe dalëse)",
      "TOTAL_ACTIVITIES": "Numri total i veprimtarive: thirrje hyrëse + thirrje dalëse + chat-e dalëse + email-e dalëse",
      "INBOUND_CALLS": "Numri i thirrjeve telefonike hyrëse të caktuara këtij agjenti",
      "OUTBOUND_CALLS": "Numri i thirrjeve telefonike dalëse të caktuara këtij agjenti",
      "AVG_FIRST_RESPONSE_TIME": "Koha mesatare nga krijimi i bisedës deri te përgjigja e parë e agjentit, në bisedat e caktuara këtij agjenti",
      "AVG_RESOLUTION_TIME": "Koha mesatare nga krijimi i bisedës deri te zgjidhja, në bisedat e caktuara këtij agjenti",
      "AVG_REPLY_TIME": "Koha mesatare që klientët presin midis mesazhit të tyre dhe përgjigjes së agjentit, në bisedat e caktuara këtij agjenti",
      "ONLINE_TIME": "Koha totale që agjenti ishte në linjë ose i zënë gjatë periudhës së zgjedhur",
      "QUEUE_AVAILABLE_TIME": "Koha totale që agjenti ishte i disponueshëm në radhët telefonike gjatë periudhës së zgjedhur"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Raportet telefonike",
    "DESCRIPTION": "Ndiqni metrikat e thirrjeve telefonike me pasqyra të detajuara mbi thirrjet hyrëse dhe dalëse, të grupuara sipas agjentit ose kutisë hyrëse për një analizë të plotë.",
    "DOWNLOAD_PHONE_REPORTS": "Shkarko raportet telefonike",
    "GROUP_BY": {
      "LABEL": "Grupo sipas",
      "AGENT": "Agjenti",
      "INBOX": "Kutia hyrëse"
    },
    "TABLE": {
      "TOTAL_CALLS": "Gjithsej",
      "INBOUND_CALLS": "Hyrëse",
      "OUTBOUND_CALLS": "Dalëse",
      "FAILED_OUTBOUND_CALLS": "Dalëse të dështuara",
      "AVG_AGENT_HANDLED_DURATION": "Kohëzgjatja mes.",
      "TOTAL_AGENT_HANDLED_DURATION": "Kohëzgjatja totale",
      "AVG_RINGING_TIME": "Koha mes. e ziles",
      "CONNECTED_OUTBOUND_PERCENTAGE": "% suksesi",
      "UNIQUE_CALLERS": "Telefonues unikë",
      "UNIQUE_CALLED_CONTACTS": "Kontakte unike të thirrura",
      "UNANSWERED_MISSED_CALLS": "Humbur pa ndjekje",
      "UNANSWERED_MISSED_PERCENTAGE": "% e humbura pa përgjigje",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Humbur pa ndjekje, të rithirrura në mënyrë të pamjaftueshme",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "% e humbura pa ndjekje, të rithirrura në mënyrë të pamjaftueshme"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Numri total i të gjitha thirrjeve (përfshirë ato të palidhura)",
      "INBOUND_CALLS": "Numri i thirrjeve të lidhura",
      "OUTBOUND_CALLS": "Numri i të gjitha thirrjeve dalëse (përfshirë ato të palidhura)",
      "FAILED_OUTBOUND_CALLS": "Numri i thirrjeve dalëse që dështuan të lidheshin",
      "AVG_AGENT_HANDLED_DURATION": "Kohëzgjatja mesatare e thirrjeve të trajtuara nga agjentët",
      "TOTAL_AGENT_HANDLED_DURATION": "Kohëzgjatja totale e të gjitha thirrjeve të trajtuara nga agjentët",
      "AVG_RINGING_TIME": "Koha mesatare që thirrjet kaluan duke rënë para se t'u përgjigjeshin",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Përqindja e thirrjeve dalëse që u lidhën me sukses",
      "UNIQUE_CALLERS": "Numri i kontakteve unike që bënë thirrje hyrëse",
      "UNIQUE_CALLED_CONTACTS": "Numri i kontakteve unike që u thirrën përmes thirrjeve dalëse",
      "UNANSWERED_MISSED_CALLS": "Numri i thirrjeve të humbura ku nuk u bë asnjë rithirrje e suksesshme (thirrje e lidhur). Mund të përfshijë thirrje që ende mund të trajtohen brenda ditës së punës",
      "UNANSWERED_MISSED_PERCENTAGE": "Përqindja e telefonuesve unikë thirrjet e të cilëve u humbën pa ndjekje (thirrje të humbura pa përgjigje / telefonues unikë)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Numri i thirrjeve të humbura me më pak se 2 përpjekje rithirrjeje. Mund të përfshijë thirrje që ende mund të trajtohen brenda ditës së punës",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Përqindja e telefonuesve unikë me më pak se 2 përpjekje rithirrjeje ((humbur pa ndjekje – trajtuar mjaftueshëm) / telefonues unikë)"
    }
  }
}
